/**
 * Auth prompt context
 *
 * Lets any control ask for a signed-in user before an action (Save, Share).
 * The App provides the value and renders the AccountPrompt dialog; after a
 * successful signup or login it runs the pending action (framing S-D4).
 */

import { createContext, useContext } from 'react';

export type AuthIntent = 'save' | 'share';

export interface AuthPromptContextValue {
  /** Ask for an account; `onAuthed` runs once the user is signed in. */
  requestAuth: (intent: AuthIntent, onAuthed: () => void) => void;
}

export const AuthPromptContext = createContext<AuthPromptContextValue | undefined>(undefined);

export function useAuthPrompt(): AuthPromptContextValue {
  const ctx = useContext(AuthPromptContext);
  if (!ctx) throw new Error('useAuthPrompt must be used within AuthPromptContext.Provider');
  return ctx;
}
